import React, { useState } from 'react';
import { View } from 'react-native-web';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Title } from 'app/src/styles';

import { CREATE_MAIL_FORWARD } from './queries';

export const FIELDS = {
  name: {
    label: 'Username',
    hint: 'Part of email address before the @',
    rules: {
      pattern: {
        value: /^[^\s@]+$/,
        message: 'Cannot include whitespace or @',
      },
      required: true,
    },
  },
  domainId: {
    label: 'Domain',
    rules: { required: true },
  },
  destination: {
    hint: 'Separate multiple addresses with semicolons',
    rules: { required: true },
  },
};

const NewMailForward = ({ setShow, refetch, domains }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createUser] = useMutation(CREATE_MAIL_FORWARD, {
    onCompleted: () => {
      refetch();
      setShow(false);
    },
    onError: () => {
      setFormStatus(null);
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');

    createUser({
      variables: { ...prepareInput(input, FIELDS) }
    });
  };

  const fields = { ...FIELDS };

  fields.domainId = {
    ...fields.domainId,
    select: [{ value: '', label: 'Select' }, ...domains],
  };

  return (
    <Modal title="Create Email Forward" setShow={setShow}>
      <Fields fields={fields} control={control} errors={errors} />

      <Button
        label="Create Email Forward"
        onPress={handleSubmit(onSubmit)}
        disabled={'submitting' === formStatus}
        wide
      />
    </Modal>
  );
};

export default NewMailForward;
